module.exports = __webpack_public_path__ + "img/160.3bd36190.png";